<template>
  <div>
    <div id="formMain">
      <div class="card">
        <div class="card-header d-flex justify-content-between">
          <h5>Convenio</h5>
          <div class="info">
            <span class="badge badge-info mr-2">Año: {{ anioGeneral }}</span>
            <span class="badge badge-info mr-2">Folio: {{ folioGeneral }}</span>
            <span class="badge badge-info">Id del Convenio: {{ idConvenioGeneral }}</span>
          </div>
        </div>

        <div class="card-body">
          <div class="row">
            <div class="col-md-3 mb-3">
              <label for="selectTipoConvenio" class="form-label">Tipo de convenio</label>
              <select id="selectTipoConvenio" class="form-control" v-model="tipoConvenio" name="tipoConvenio"
                :disabled="idConvenioGeneral !== '' && dsbld==true" required>
                <option v-for="(tipo, i) in tiposConvenios" :key="i" :value="tipo.idTipoConvenio">
                  {{ tipo.tipoConvenio }}
                </option>
              </select>
            </div>

            <div class="col-md-3 mb-3">
              <label for="selectBancos" class="form-label">Banco</label>
              <select id="selectBancos" class="form-control" v-model="banco" name="banco"
                @change="changeDigiCardDigits($event.target.value)" :disabled="idConvenioGeneral !== '' && dsbld==true"
                required>
                <option v-for="(tipo, i) in bancos" :key="i" :value="tipo.idBanco">
                  {{ tipo.banco }}
                </option>
              </select>
            </div>

            <div class="col-md-3 mb-3">
              <label for="inputCorreo" class="form-label">Correo electronico</label>
              <input type="text" class="form-control" id="inputCorreo" v-model="email" name="email" required />
            </div>

            <div class="col-md-3 mb-3">
              <label for="selectTipoPago" class="form-label">Tipo de Tarjeta</label>
              <select id="selectTipoPago" class="form-control" v-model="tipoTarjeta" name="tipoTarjeta"
                :disabled="idConvenioGeneral !== '' && dsbld==true" required>
                <option v-for="(tipo, i) in tiposTarjetas" :key="i" :value="tipo.idTipoElemento">
                  {{ tipo.tipoElemento }}
                </option>
              </select>
            </div>

            <div class="col-md-3 mb-3">
              <label for="selectSituacionDelConvenio" class="form-label">Situación del convenio</label>
              <select :disabled="tipoUsuario == 'AGENTE'" id="selectSituacionDelConvenio" class="form-control" v-model="situacionConvenio"
                name="situacionConvenio" required>
                <!-- <option v-for="(tipo, i) in situacionConvenios" :key="i" :value="(tipoUsuario == 'AGENTE') ? situacionConvenios[1].idSituacionConvenio :tipo.idSituacionConvenio"> -->
                <option v-for="(tipo, i) in situacionConvenios" :key="i" :value="tipo.idSituacionConvenio">
                  {{ (tipoUsuario == "AGENTE") ? situacionConvenios[1].situacionConvenio : tipo.situacionConvenio}}
                </option>
              </select>
            </div>

            <div class="col-md-3 mb-3">
              <label for="inputPhone" class="form-label">Teléfono</label>
              <input class="form-control" id="inputPhone" v-model="telefono" name="telefono" maxlength="10" v-on:keyup="replaceTelefono" required />
            </div>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header">
          <h5>Tarjeta</h5>
        </div>
        <div class="card-body d-flex flex-wrap">
          <div class="col-sm-12 col-lg-4 form-group">
            <label>Numero de tarjeta</label>
            <div class="input-group">
              <input type="text" class="form-control" placeholder="XXXX XXXX XXXX 0000" v-model="numeroTarjeta"
                v-on:keyup="replaceTarget" :disabled="numeroTarjeta !== '' && idConvenioGeneral !== '' && dsbld==true"
                :maxlength="maxL" required />
              <button v-if="tipoUsuario === 'COBRANZAS'" class="btn btn-secondary" type="button" data-bs-toggle="modal" data-bs-target="#showModalLock"
                @click="typeShow = 'tarjeta'">
                <i class="fas fa-eye"></i>
              </button>
            </div>
          </div>

          <div class="col-lg-4 form-group">
            <label>Titular</label>
            <input type="text" class="form-control" placeholder="Nombre" v-model="titular" name="titular"
              :disabled="idConvenioGeneral !== '' && dsbld==true" requerid />
          </div>

          <div class="col-lg-2 col-sm-6 form-group">
            <label>Vencimiento</label>
            <input type="text" class="form-control" placeholder="Mes" v-model="mesVencimiento" name="mesVencimiento"
              v-on:keyup="replaceMes" required maxlength="2" />
          </div>

          <div class="col-lg-2 col-sm-6 form-group">
            <label style="margin-left: 6rem; color: white;">.</label>
            <input type="text" class="form-control" placeholder="Año" v-model="anioVencimiento" name="anioVencimiento"
              v-on:keyup="replaceAnio" required maxlength="4" />
          </div>


          <div class="col-sm-3 col-lg-4 form-group">
            <label>CVV</label>
            <div class="input-group">
              <input type="text" class="form-control" placeholder="XXX" v-model="cvvTarjeta" :maxlength="maxCVV"
                v-on:keyup="replaceCVV" name="cvvTarjeta" :disabled="idConvenioGeneral !== '' && dsbld==true"
                required />
              <button class="btn btn-secondary" type="button" data-bs-toggle="modal" data-bs-target="#showModalLock"
                @click="typeShow = 'cvv'" v-if="tipoUsuario === 'COBRANZAS'">
                <i class="fas fa-eye"></i>
              </button>
            </div>
          </div>

          <div class="col-md-4 mb-3">
            <label for="selectSituacion" class="form-label">Situación</label>
            <select :disabled="tipoUsuario == 'AGENTE'" id="selectSituacion" class="form-control" v-model="situacion" name="situacion" required>
              <option v-for="(tipo, i) in situacionElemento" :key="i" :value="tipo.idSituacionElemento">
                {{ (tipoUsuario == "AGENTE") ? situacionElemento[1].situacionElemento : tipo.situacionElemento }}
              </option>
            </select>
          </div>

          <div class="col-sm-3 col-lg-4 form-group">
            <label>Dia de programación</label>
            <input type="text" class="form-control" placeholder="Dia" v-model="diaProgramacion"
              name="diaProgramacion" />
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-header d-flex justify-content-between">
          <h5>Asignación de pólizas</h5>
          <button class="btn btn-sm btn-info" @click="limpiarBuscador(true, true)"
            :disabled=" idConvenioGeneral == null || idConvenioGeneral == '' ? true : false ">
            <i class="fas fa-search"></i> Buscar
          </button>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <table class="table table-stripped">
              <thead class="thead-dark">
                <tr>
                  <th>Sistema</th>
                  <th>Póliza</th>
                  <th>Renov / Ramo</th>
                  <th>No. Filial</th>
                  <th>Nombre filial</th>
                  <th>Endoso</th>
                  <th>IdAgente</th>
                  <th>Eliminar</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(result, i) in asignacionPolizas" :key="i">
                  <td>{{ result.sistema }}</td>
                  <td>{{ result.poliza }}</td>
                  <td>{{ result.ramoRen }}</td>
                  <td>{{ (result.numFilial !== -1) ? result.numFilial : "" }}</td>
                  <td>
                    {{ result.nombreFilial }}
                  </td>
                  <td>{{ (result.endoso !== -1) ? result.endoso : "" }}</td>
                  <td>{{ result.idAgente}}</td>
                  <td>
                    <button class="btn btn-sm btn-danger" @click="eliminarPolizas(result)">
                      <i class="fa-solid fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>

    <div class="col-12 d-flex justify-content-end">
      <button class="btn btn-success mr-2"
        @click="alertConfirmationConvenio('nuevo', '¿Estas seguro que quieres generar un nuevo convenio?')">Nuevo</button>
      <button class="btn btn-danger mr-2"
        @click="alertConfirmationConvenio('eliminar', '¿Estas seguro que quieres eliminar el convenio?')"
        v-if="isNew && tipoUsuario === 'COBRANZAS'">Eliminar</button>
      <button class="btn btn-warning mr-2"
        @click="alertConfirmationConvenio('duplicar', '¿Estas seguro que quieres duplicar el convenio?')"
        v-if="duplicar">Duplicar</button>

      <div v-if="!duplicar" class="">
        <button class="btn btn-warning mr-2"
          @click="alertConfirmationConvenio('habilitar', '¿Estas seguro que quieres duplicar el convenio?')"
          v-if="isNew && showB">Duplicar</button>
        <button class="btn btn-primary"
          @click="alertConfirmationConvenio('guardar', '¿Estas seguro que quieres guardar el convenio?')">Guardar</button>
      </div>

    </div>

    <!-- modal detalle del resultado -->
    <CModal size="lg" :show.sync="modals" ref="my-modal" :close-on-backdrop="false">
      <template #footer-wrapper><span></span></template>
      <div class="card-body p-0 d-flex flex-wrap" id="formBuscar">
        <div class="form-group col-lg-4">
          <label for="selectSistema" class="form-label">Sistema</label>
          <select id="selectSistema" class="form-control" v-model="sistema" name="sistema"
            @change="limpiarBuscador(true, true)">
            <option v-for="(tipo, i) in sistemas" :key="i" :value="tipo.id">
              {{ tipo.sistema }}
            </option>
          </select>
        </div>
        <div class="form-group col-lg-4" :hidden="sistema === 0">
          <label for="">Póliza</label>
          <input class="form-control" name="poliza" v-model="poliza" />
        </div>
        <div class="form-group col-lg-4" :hidden="sistema === 1 || sistema === 0">
          <label for="">Endoso</label>
          <input class="form-control" name="endoso" v-model="endoso" />
        </div>
        <div class="form-group col-lg-4" :hidden="sistema === 1 || sistema === 0">
          <label for="">No. Filial</label>
          <input class="form-control" name="noFilial" v-model="noFilial" />
        </div>
        <div class="form-group col-lg-4" :hidden="sistema === 1 || sistema === 0">
          <label for="">Nombre filial</label>
          <input class="form-control" name="nombreFilial" v-model="nombreFilial" />
        </div>
        <div class="form-group col-lg-4" :hidden="sistema === 2 || sistema === 0">
          <label for="">Ramo</label>


          <select id="selectRamo" class="form-control" v-model="ramo" name="ramo" required>
            <option v-for="(ramo, i) in ramosDanios" :key="i" :value="ramo.claveRamo">
              {{ ramo.ramo }}
            </option>
          </select>


          <!-- <input class="form-control" name="ramo" v-model="ramo" /> -->
        </div>
      </div>

      <div class="col-12 d-flex justify-content-end">
        <button class="btn btn-primary" :hidden="sistema === 0" @click="busquedaDaniosPersonas">Buscar</button>
      </div>

      <div class="card-footer p-0 mt-3">
        <div class="table-responsive">

          <v-table :data="polizasBuscador" :currentPage.sync="currentPage" :pageSize="10"
            @totalPagesChanged="totalPages = $event" class="table table-striped">

            <!-- persona -->
            <thead slot="head" v-if="sistema === 2 || sistema === 1">
              <tr v-if="sistema === 2">
                <th>Sistema</th>
                <th>Póliza</th>
                <th>Renov/Ramo</th>
                <th>Endoso</th>
                <th>No. Filial</th>
                <th>Nombre filial</th>
                <th>Seleccionar</th>
              </tr>
              <tr v-if="sistema === 1">
                <th>Sistema</th>
                <th>Póliza</th>
                <th>Renov/Ramo</th>
                <th>Endoso</th>
                <th>Seleccionar</th>
              </tr>
            </thead>

            <!-- persona -->
            <tbody slot="body" slot-scope="{ displayData }" v-if="sistema === 2 || sistema === 1">
              <tr v-for="result in displayData" :key="result.guid" v-if="sistema === 2">
                <td>{{ result.sistemA_ORIGEN }}</td>
                <td>{{ result.nuM_POLIZA }}</td>
                <td>{{ result.nuM_RENOV_POL }}</td>
                <td>{{result.endoso}}</td>
                <td v-if="sistema === 2">{{ result.iD_FILIAL }}</td>
                <td v-if="sistema === 2">
                  {{ result.nombre }}
                </td>
                <td class="text-center">
                  <input type="checkbox" v-model="result.check" />
                </td>
              </tr>

              <tr v-for="result in displayData" :key="result.guid" v-if="sistema === 1">
                <td>Daños</td>
                <td>{{ result.NumeroPoliza }}</td>
                <td>{{ result.Ramo }}</td>
                <td>{{ result.NumeroEndoso }}</td>
                <td class="text-center">
                  <input type="checkbox" v-model="result.check" />
                </td>
              </tr>


              <tr>
                <td colspan="6">
                  <div class="col-12 d-flex justify-content-between pr-0">
                    <div class="folio d-flex justify-content-start">
                      <label for="folio" class="mr-3 mt-2">Folio</label>
                      <input type="text" v-model="folio" class="form-control" placeholder="Folio">
                    </div>
                    <button class="btn btn-success" @click="agregarPolizas">Agregar</button>
                  </div>
                </td>
              </tr>
            </tbody>
          </v-table>
        </div>
      </div>

      <div class="table-responsive">
        <smart-pagination :currentPage.sync="currentPage" :totalPages="totalPages" />
      </div>

      <CCardFooter align="right" class="pt-3 pl-0 pr-0 pb-0">
        <CButton @click="limpiarBuscador(false, true)" color="outline-secondary">Cerrar
        </CButton>
      </CCardFooter>
    </CModal>

    <!-- Modal mostrar contraseña -->
    <div class="modal fade" id="showModalLock" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalAccesoLabel">Mostrar</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
              id="closeModalPassword"></button>
          </div>
          <div class="modal-body" id="formAcceso">
            <div class="row">
              <div class="col-md-12" v-if="alertMessage !== ''">
                <div class="alert alert-danger" role="alert">
                  {{ alertMessage }}
                </div>
              </div>
              <div class="col-md-12">
                <label for="inputPasswordAccess" class="form-label">Favor de indicar su contraseña</label>
                <input type="password" class="form-control" id="inputPasswordAccess" v-model="passwordAccess"
                  name="passwordAccess" autocomplete="off" required />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
            <button type="button" class="btn btn-primary" @click="accesoMostrarInfo">
              Mostrar
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- Modal de recuperar contraseña -->
    <div class="modal fade" id="modalChangePassword" tabindex="-1" aria-labelledby="modalChangePasswordLabel"
      aria-hidden="true">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="modalChangePasswordLabel">Cambio contraseña</h5>
            <button id="closeModalChangePassword" type="button" class="btn-close" data-bs-dismiss="modal"
              aria-label="Close"></button>
          </div>
          <div class="modal-body" id="formChangePassword">
            <div class="row">
              <div class="col-md-12" v-if="alertMessageChangePasswordError !== ''">
                <div class="alert alert-danger" role="alert">
                  {{ alertMessageChangePasswordError }}
                </div>
              </div>
              <div class="col-md-12" v-if="alertMessageChangePasswordSuccess !== ''">
                <div class="alert alert-success" role="alert">
                  {{ alertMessageChangePasswordSuccess }}
                </div>
              </div>
              <div class="col-md-12">
                <label for="inputNuevaContrasena" class="form-label">Escribir nueva contraseña</label>
                <input type="password" class="form-control" id="inputNuevaContrasena" v-model="newPassword"
                  name="newPassword" autocomplete="off" required />
              </div>
              <div class="col-md-12">
                <label for="inputConfirmarContrasena" class="form-label">Confirmar nueva contraseña</label>
                <input type="password" class="form-control" id="inputConfirmarContrasena" v-model="confirmPassword"
                  name="confirmPassword" autocomplete="off" required />
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
              Cerrar
            </button>
            <button type="button" class="btn btn-primary" @click="changePassword">
              Guardar
            </button>
          </div>
        </div>
      </div>
    </div>

    <button id="btnModalChangePassword" type="button" class="btn btn-primary" data-bs-toggle="modal"
      data-bs-target="#modalChangePassword" style="display: none">
      Change Password
    </button>

  </div>
</template>

<script>
import FormBuilder from "../../../componentes/form/FormBuilder.vue";
import { form } from "../../../assets/helpers";
import LoginVue from "../../pages/Login.vue";
import axios from 'axios';

export default {
  components: {
    FormBuilder,
  },
  data() {
    return {
      isNew: false,
      isNewDelete: false,
      modals: false,
      maxL: 19,
      maxCVV: 3,
      sis: true,
      showB: true,
      numT: "",
      dsbld: true,
      duplicar: false,
      anioAct: "",
      err: "",

      modalTest: true,

      idConvenioGeneral: "",
      idCEGeneral: "",
      idElementoGeneral: "",

      anioGeneral: "",
      folioGeneral: "",

      tiposConvenios: [],
      ramosDanios: [],
      bancos: [],
      tiposTarjetas: [],
      situacionConvenios: [],
      tipoConvenio: 0,
      banco: 0,
      tipoTarjeta: 0,
      situacionConvenio: 0,
      email: "",
      telefono: "",

      situacionElemento: [],
      situacion: 0,
      numeroTarjeta: "",
      titular: "",
      mesVencimiento: "",
      anioVencimiento: "",
      cvvTarjeta: "",
      diaProgramacion: "",
      tarjetaEncriptada: "",
      cvvEncriptada: "",
      codigoAgente: "",

      sistemas: [],
      sistema: 1,
      poliza: "",
      endoso: "",
      noFilial: "",
      nombreFilial: "",
      ramo: 0,
      folio: "",

      correoCerrado: "",
      telefonoCerrado: "",
      mesCerrado: "",
      titularCerrado: "",
      
      currentPage: 1,
      totalPages: 0,

      asignacionPolizas: [],
      polizasBuscador: [],

      typeShow: "",
      alertMessage: "",
      passwordAccess: "",

      newPassword: "",
      confirmPassword: "",
      alertMessageChangePasswordError: "",
      alertMessageChangePasswordSuccess: "",

      userId: localStorage.getItem("userId"),
      UsuarioRegistro: "",
      tipoUsuario: ""
    };
  },
  methods: {
    async consultaRol() {
      const payload = {
        metodo: "CONSULTAROL",
        data: {
          pIdUsuarioApp: this.userId,		
          pAplicacion: "DOMICILIADOS"
        },
      };
      console.log(payload);
      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        console.log(response);
        this.UsuarioRegistro = response[0].idusuario
        // this.tipoUsuario = "COBRANZA"
        this.tipoUsuario = response[0].descripcion
        console.log(this.tipoUsuario);

      }
    },
    changeDigiCardDigits(event) {
      if (event == 16) {
        this.maxL = 18;
        this.maxCVV = 4;
      }
      else {
        this.maxL = 19;
        this.maxCVV = 3;
      }
    },
    async obtenerCatalogo(tipo) {
      const payload = {
        metodo: "COBRANZACONSULTACATALOGO",
        data: {
          pIdUsuario: localStorage.getItem("userId"),
          pOpcion: tipo,
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;


        switch (tipo) {
          case "TipoConvenio":
            this.tiposConvenios.push(...response);
            break;
          case "Bancos":
            this.bancos.push(...response);
            break;
          case "TipoElemento":
            this.tiposTarjetas.push(...response);
            break;
          case "SituacionConvenio":
            this.situacionConvenios.push(...response);
            break;
          case "SituacionElemento":
            this.situacionElemento.push(...response);
            break;
          case "Sistema":
            this.sistemas.push(...response);
            break;
          case "RamosDanios":
            this.ramosDanios.push(...response);
            break;
          default:
            break;
        }
      }
    },
    async busquedaDaniosPersonas() {


      this.polizasBuscador = [];
      if (this.poliza == '' || this.poliza == null) {
        this.$swal("Error", "Debe indicar mínimo el Filtro de Póliza");
      } else {


        switch (this.sistema) {
          case 1:
            await this.busquedaPolizaD();
            break;
          case 2:
            await this.busquedaPolizaP();
            break;
          default:
            break;

        }
        this.limpiarBuscador(true, false);
      }


    },
    async busquedaPolizaD() {


      this.sis = true;

      this.polizasBuscador = [];

      const payload = {
        metodo: "COBRANZABUSQUEDAPOLIZAD",
        data: {
          Poliza: this.poliza !== "" ? this.poliza : "-1",
          Ramo: this.ramo !== 0 ? this.ramo : -1,
          Endoso: this.endoso !== "" ? this.endoso : "-1",
          // Folio: this.folio !== "" ? this.folio : "",
          Agente: this.tipoUsuario != "COBRANZAS" ?  localStorage.getItem("userId") : "-1",
          IdUsuarioLogueado: localStorage.getItem("userId"),
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST.Endosos;

        if (this.$store.getters.getRespuestaREST.Comando == "") {
          this.$swal("Alerta", "No se encontró información");
        }
        else {
          this.polizasBuscador.push(...response);
          this.codigoAgente = response[0].CodigoAgente;
        }
      }
    },
    async altaConvenio() {
      this.isNew = false;
      
      if (this.numeroTarjeta.indexOf('X') >= 0) {
        this.$swal("Alerta", "El formato de Número de Tarjeta es invalido");
        return;
      }
      
      let validateOnlyNumbers = new RegExp(/^([0-9])*$/);
      if (!validateOnlyNumbers.test(this.mesVencimiento)) {
        this.$swal("Alerta", "El formato de Mes de vencimiento es invalido");
        console.log("o aqui");
        return;
      }
      let validateLetters = new RegExp("^[ a-zA-ZñÑáéíóúÁÉÍÓÚ]+$");
      if (!validateLetters.test(this.titular)) {
        this.$swal("Alerta", "El Titular es invalido");
        console.log("o aqui");
        return;
      }

      if (!validateOnlyNumbers.test(this.anioVencimiento)) {
        this.$swal("Alerta", "El formato de Año de vencimiento es invalido");
        return;
      }
      if (!validateOnlyNumbers.test(this.cvvTarjeta)) {
        this.$swal("Alerta", "El formato de CVV es invalido");
        return;
      }

      let codificadoTarjeta = btoa(this.numTarjeta);

      const payload = {
        metodo: "COBRANZAALTACONVENIO",
        data: {
          pIdBanco: this.banco,
          pIdTipoElemento: this.tipoTarjeta,
          // pNumConvenio: this.numTarjeta,
          pNumConvenio: btoa(this.numeroTarjeta.trim().replace(/\s+/g, '')),
          pValor1: btoa(this.mesVencimiento),
          pValor2: btoa(this.anioVencimiento),
          pValor3: btoa(this.cvvTarjeta),
          pDiaProgramacion: this.diaProgramacion,
          pIdSituacionElemento: (this.tipoUsuario == "AGENTE") ? 1 : this.situacion,
          pTitular: this.titular,
          p1IdTipoConvenio: this.tipoConvenio,
          p1Correo: this.email,
          p1Telefono: this.telefono,
          p1IdSituacionConvenio: (this.tipoUsuario == "AGENTE") ? 1 : this.situacionConvenio,
          pUsuarioRegistro: localStorage.getItem("userId"),
        },
      };
      console.log(payload);
      try {
        const res = await this.$store.dispatch("metodoPost", payload);
        if (res) {
          const response = this.$store.getters.getRespuestaREST;
          if(response[0].valor == "-1"){
            this.$swal({
              icon: 'error',
              title: 'Error',
              text: response[0].mensaje,
            });
          } else {
            this.anioGeneral = response[0].anio;
            this.folioGeneral = response[0].folio;
            this.idCEGeneral = response[0].idCE;
            this.idElementoGeneral = response[0].idElem;
            this.idConvenioGeneral = response[0].valor;
            this.$swal("Exito", "Convenio dado de alta exitosamente");
            window.location.href = `${location.origin}/#/cobranza/convenios?idConvenio=${this.idConvenioGeneral}&idElemento=${this.idElementoGeneral}&idCE=${this.idCEGeneral}`;
            location.reload();

          }
          
        }

      } catch (error) {
        this.$swal("Error", "Comunicate con el administrador");
      }




    },
    enableInputs() {
      this.changeDigiCardDigits(this.banco);
      this.dsbld = false;
      this.cvvTarjeta = "";
    },
    async duplicaConvenio() {

      let polizasRequest = [];
      if (this.numeroTarjeta.indexOf('pValor1') >= 0) {
        this.$swal("Alerta", "El formato de Número de Tarjeta es invalido");
        return;
      }
      for (let index = 0; index < this.asignacionPolizas.length; index++) {

        if (this.sistema === 1) {

          let ramoTemp = this.asignacionPolizas[index].ramoRen.toString();

          const valuePoliza = {
            pPoliza: this.asignacionPolizas[index].poliza.toString(),
            pRamo: ramoTemp.length == 1 ? "0" + ramoTemp : this.asignacionPolizas[index].ramoRen.toString(),
            pRenovacion: "-1",
            pEndoso: this.asignacionPolizas[index].endoso != null || this.asignacionPolizas[index].endoso != "" ? this.asignacionPolizas[index].endoso.toString() : "-1",
            pNumFilial: "-1",
            pNombreFilial: "-1",
            pFolio: "-1",
            pIdSistema: "1",
            pIdAgente: this.asignacionPolizas[0].idAgente
          };

          polizasRequest.push(valuePoliza);
        }
        else if (this.sistema === 2) {
          let ramoTemp = this.asignacionPolizas[index].ramoRen.toString();

          const valuePoliza = {
            pPoliza: this.asignacionPolizas[index].poliza.toString(),
            pRamo: "-1",
            pRenovacion: this.asignacionPolizas[index].ramoRen.toString(),
            pEndoso: this.asignacionPolizas[index].endoso != null || this.asignacionPolizas[index].endoso != "" ? this.asignacionPolizas[index].endoso.toString() : "-1",
            pNumFilial: this.asignacionPolizas[index].numFilial != null || this.asignacionPolizas[index].numFilial != "" ? this.asignacionPolizas[index].numFilial.toString() : "-1",
            pNombreFilial: this.asignacionPolizas[index].nombreFilial != null || this.asignacionPolizas[index].nombreFilial != "" ? this.asignacionPolizas[index].nombreFilial.toString() : "-1",
            pFolio: "-1",
            pIdSistema: "2",
            pIdAgente: this.asignacionPolizas[0].idAgente
          };

          polizasRequest.push(valuePoliza);
        }
      }

      const payload = {
        metodo: "COBRANZADUPLICACONVENIO",
        data: {
          pIdConvenio: this.idConvenioGeneral.toString(),
          pIdElemento: this.idElementoGeneral.toString(),
          pIdCE: this.idCEGeneral.toString(),
          pSigue: "-1",
          pUsuarioRegistro: localStorage.getItem("userId"),
          pDatosNuevo: {
            pIdBanco: this.banco.toString(),
            pIdTipoElemento: this.tipoTarjeta.toString(),
            pNumConvenio: btoa(this.numeroTarjeta.trim().replace(/\s+/g, '')),
            pValor1: btoa(this.mesVencimiento),
            pValor2: btoa(this.anioVencimiento),
            pValor3: btoa(this.cvvTarjeta),
            pDiaProgramacion: this.diaProgramacion.toString(),
            pIdSituacionElemento: this.situacion.toString(),
            pTitular: this.titular,
            p1IdTipoConvenio: this.tipoConvenio.toString(),
            p1Correo: this.email,
            p1Telefono: this.telefono,
            p1IdSituacionConvenio: this.situacionConvenio.toString(),
            pUsuarioRegistro: localStorage.getItem("userId"),
            pCorreoCerrado: this.correoCerrado,
            pTelefonoCerrado: this.telefonoCerrado,
            pValor1Cerrado: this.mesCerrado,
            ptitularCerrado: this.titularCerrado
          },
          pPolizasNuevo: polizasRequest
        },
      };
      console.log(payload);
      const res = await this.$store.dispatch("metodoPost", payload);

      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        console.log(response);
        if (response[0].valor === -1) {
          this.$swal("Error", response[0].mensaje);
          return;
        }
        else {
          // this.$swal("Exito", response[0].mensaje);
          this.anioGeneral = response[0].anio;
          this.folioGeneral = response[0].folio;
          this.idCEGeneral = response[0].idCE;
          this.idElementoGeneral = response[0].idElem;
          this.idConvenioGeneral = response[0].valor;


          await this.$swal.fire({
            title: "Exito",
            text: response[0].mensaje + "",
            confirmButtonText: 'OK',
            reverseButtons: true
          }).then(async (result) => {

            if (result) {
              window.location.href = `${location.origin}/#/cobranza/convenios?idConvenio=${this.idConvenioGeneral}&idElemento=${this.idElementoGeneral}&idCE=${this.idCEGeneral}`;
              location.reload();
            }
          });
        }
        // this.numeroTarjeta
      }
    },
    async eliminaConvenio() {
      const payload = {
        metodo: "COBRANZAELIMINACONVENIO",
        data: {
          pIdConvenio: this.idConvenioGeneral,
          pIdElemento: this.idElementoGeneral,
          pIdCE: this.idCEGeneral,
          pSigue: "-1",
          pUsuarioRegistro: localStorage.getItem("userId"),
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);

      if (res) {
        const _ = this.$store.getters.getRespuestaREST;

        if (_[0].valor > 0) {

          this.$swal("Exito", "" + _[0].mensaje);
          this.clearGeneralForm();
          window.location.href = `${location.origin}/#/cobranza/convenios`;
        } else {
          this.$swal("Error", "" + _[0].mensaje);

        }
      }
    },
    async agregarPolizas() {

      const polizas = this.polizasBuscador.filter(pol => pol.check);

      if (polizas.length > 0) {

        const polizasCheck = [];



        if (this.sistema == 2) {
          polizas.map(pol => {
            polizasCheck.push({
              pPoliza: pol.nuM_POLIZA,
              pRamo: (this.ramo) ? this.ramo : "-1",
              pRenovacion: pol.nuM_RENOV_POL,
              pEndoso: pol.endoso,
              pNumFilial: pol.iD_FILIAL ? pol.iD_FILIAL : "-1",
              pNombreFilial: (pol.nombre) ? pol.nombre : "-1",
              pFolio: (this.folio) ? this.folio : "-1",
              pIdSistema: (this.sistema) ? this.sistema : "-1",
              pIdAgente: this.codigoAgente
            });
          });
        } else if (this.sistema == 1) {
          polizas.map(pol => {
            polizasCheck.push({
              pPoliza: pol.NumeroPoliza ? pol.NumeroPoliza : "-1",
              pRamo: (pol.Ramo) ? pol.Ramo : "-1",
              pRenovacion: "-1",
              pEndoso: pol.NumeroEndoso ? pol.NumeroEndoso : "-1",
              pNumFilial: pol.iD_FILIAL ? pol.iD_FILIAL : "-1",
              pNombreFilial: (pol.nombre) ? pol.nombre : "-1",
              pFolio: (this.folio) ? this.folio : "-1",
              pIdSistema: (this.sistema) ? this.sistema : "-1",
              pIdAgente: this.codigoAgente
            });
          });
        }
        const payload = {
          metodo: "COBRANZAAGREGARPOLIZAS",
          data: {
            pIdConvenio: this.idConvenioGeneral,
            pIdElemento: this.idElementoGeneral,
            pPolizas: polizasCheck,
            pUsuarioRegistro: localStorage.getItem("userId"),
          },
        };
        console.log(payload);

        const res = await this.$store.dispatch("metodoPost", payload);
        if (res) {
          const response = this.$store.getters.getRespuestaREST;

          this.limpiarBuscador(false, false);
          this.modals = false;

          await this.consultaDetallesConvenio();

          this.$swal.fire({
            html: response[0].mensaje
          });
        }
      }
    },
    async eliminarPolizas(poliza) {

      await this.$swal.fire({
        title: 'Estas seguro de que quieres eliminar la poliza?',
        text: "Esta acción no se puede revertir",
        showCancelButton: true,
        confirmButtonText: 'Si, aceptar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
      }).then(async (result) => {
        if (result.isConfirmed) {

          const payload = {
            metodo: "COBRANZAELIMINAPOLIZAS",
            data: {
              pIdConvenio: this.idConvenioGeneral,
              pIdElemento: this.idElementoGeneral,
              pUsuarioRegistro: localStorage.getItem("userId"),
              pPolizas: [
                {
                  pPoliza: poliza.poliza,
                  pRamo: (poliza.ramoRen).toString(),
                  pRenovacion: "-1",
                  pEndoso: (poliza.endoso).toString(),
                  pNumFilial: (poliza.numFilial).toString(),
                  pFolio: (poliza.folioTicket) ? poliza.folioTicket : "-1",
                  pIdSistema: (poliza.idSistema).toString(),
                  pNombreFilial: (poliza.nombreFilial) ? poliza.nombreFilial : "-1",
                }
              ]
            },
          };

          const res = await this.$store.dispatch("metodoPost", payload);
          if (res) {
            const response = this.$store.getters.getRespuestaREST;
            this.$swal("Exito", response[0].mensaje);

            await this.consultaDetallesConvenio();
          }
        }
      })
    },
    async actualizarConvenio() {
      this.isNew = true
      const payload = {
        metodo: "COBRANZAACTUALIZACONVENIO",
        data: {
          pIdConvenio: this.idConvenioGeneral,
          pIdElemento: this.idElementoGeneral,
          pValor1: btoa(this.mesVencimiento),
          pValor2: btoa(this.anioVencimiento),
          // pValor3: this.cvvTarjeta,
          pDiaProgramacion: this.diaProgramacion,
          pIdSituacionElemento: this.situacion,
          p1Correo: this.email,
          p1Telefono: this.telefono,
          p1IdSituacionConvenio: this.situacionConvenio,
          pUsuarioRegistro: localStorage.getItem("userId"),
          pCorreoCerrado: this.correoCerrado,
          pTelefonoCerrado: this.telefonoCerrado,
          pValor1Cerrado: this.mesCerrado,
        },
      };
      console.log(payload);
      // if (payload.data.pValor1.length < 2 || payload.data.pValor1.length > 2) {
      //   this.$swal("Advertencia", "El formato de Mes de vencimiento es incorrecto");
      //   return;
      // }
      // if (payload.data.pValor2.length < 4 || payload.data.pValor2.length > 4) {
      //   this.$swal("Advertencia", "El formato de Año de vencimiento es incorrecto");
      //   return;
      // }


      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        this.$swal("Exito", "" + this.$store.getters.getRespuestaREST[0].mensaje);
        this.showB = true;
      }


    },
    async busquedaPolizaP() {

      this.sis = false;

      const fakeForm = document.querySelector("#formBuscar");

      if (!form.validate(fakeForm)) {
        this.alertMessage = "Todos los campos son obligatorios";
        return;
      }

      const payload = {
        // method: "POST",
        // url: "cobranza/api/v1/Convenios/BusquedaPolizaP",
        // headers: {
        //   "Content-Type": "application/json",
        //   XAPPID: this.$store.state.config.headers.XAPPID,
        //   'Authorization': 'Bearer ' + this.$store.state.token
        // },
        metodo: "COBRANZABUSQUEDAPOLIZAP",
        data: {
          Poliza: this.poliza !== "" ? this.poliza : "-1",
          Ramo: "-1",
          Endoso: this.endoso !== "" ? this.endoso : "-1",
          Filial: this.nombreFilial !== "" ? this.nombreFilial : "-1",
          IdFilial: this.noFilial !== "" ? this.noFilial : "-1",
          // Folio: this.folio !== "" ? this.folio : "",
          Agente: this.tipoUsuario != "COBRANZAS" ?  localStorage.getItem("userId") : "-1",
          IdUsuarioLogueado: localStorage.getItem("userId"),
        },
      };

      // this.$store.commit('showLoading')
      // await axios(payload)
      //   .then(function (response) {
      //     console.log(response);
      //     // if (response.status === 200) {
      //     //   console.log(response);
      //     //   if (response.data.flag) {
      //     //     const tmp = response.data.data;
      //     //     console.log(tmp);
      //     //   }
      //     // }
      //   }).catch(function (error) {
      //     console.log(error);
      //   });
        


      const res = await this.$store.dispatch("metodoPost", payload);

          if (res) {
          const response = this.$store.getters.getRespuestaREST;
          if (this.$store.getters.getRespuestaREST.length == 0) {
            this.$swal("Alerta", "No se encontró información");
          } 
          else {
            this.polizasBuscador.push(...response);
            this.codigoAgente = response[0].iD_AGENTE;
          }
        }

    },
    async consultaDetallesConvenio() {

      const payload = {
        metodo: "COBRANZACONSULTADETALLESCONVENIO",
        data: {
          pIdConvenio: this.idConvenioGeneral,
          pIdElemento: this.idElementoGeneral,
          pIdCE: this.idCEGeneral,
          pSigue: "-1",
          pUsuarioRegistro: localStorage.getItem("userId"),
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        const response = this.$store.getters.getRespuestaREST;
        const convenio = response.convenio[0];
        console.log(convenio);

        this.anioGeneral = convenio.anio;
        this.folioGeneral = convenio.folio;

        this.email = convenio.correo;
        this.tipoConvenio = convenio.idTipoConvenio;
        this.banco = convenio.idBanco;
        this.tipoTarjeta = convenio.idTipoElemento;
        this.situacionConvenio = convenio.idSituacionConvenio;
        this.telefono = convenio.telefono;
        this.tarjetaEncriptada = convenio.valorPrincipal;
        this.cvvEncriptada = convenio.cerrado3;

        this.numeroTarjeta = convenio.numConvenio;
        this.titular = convenio.titular;
        this.mesVencimiento = convenio.valor1;
        this.anioVencimiento = convenio.valor2;
        this.cvvTarjeta = convenio.valor3;
        this.situacion = convenio.idSituacionElemento;
        this.diaProgramacion = convenio.diaProgramacion;

        this.asignacionPolizas = response.polizasAsignadas; 

        this.correoCerrado = convenio.correoCerrado
        this.telefonoCerrado = convenio.telefonoCerrado
        this.mesCerrado = convenio.valor1Cerrado
        this.titularCerrado = convenio.titularCerrado

        console.log(this.correoCerrado);
        console.log(this.telefonoCerrado);
        console.log(this.mesCerrado);
        console.log(this.titularCerrado);

      }
    },
    async accesoMostrarInfo() {
      const fakeForm = document.querySelector("#formAcceso");

      if (!form.validate(fakeForm)) {
        this.alertMessage = "Todos los campos son obligatorios";
        return;
      }

      const payload = {
        metodo: "COBRANZAACCESOMOSTRARINFO",
        data: {
          pContra: this.passwordAccess,
          pIdUsuario: localStorage.getItem("userId"),
          pIdUsuarioRegistro: this.typeShow === "tarjeta" ? this.tarjetaEncriptada : this.cvvEncriptada,
          pActivo: "1",
        },
      };

      const res = await this.$store.dispatch("metodoPost", payload);
      if (res) {
        // o¡3cOnt4r90

        const response = this.$store.getters.getRespuestaREST;

        this.alertMessage = "";
        this.passwordAccess = "";


        if (response[0].valor === -1 && response[0].mensaje === "La contraseña está expirada, Favor de cambiarla") {
          this.showModalChangePassword();
          this.alertMessage = response[0].mensaje;
          document.getElementById("closeModalPassword").click();
        } else if (response[0].valor === -1) {
          this.alertMessage = response[0].mensaje;
        } else {
          this.typeShow === "tarjeta" ? this.numeroTarjeta = response[0].mensaje : this.cvvTarjeta = response[0].mensaje;
          document.getElementById("closeModalPassword").click();
        }
      }
    },
    async showModalChangePassword() {
      document.getElementById("btnModalChangePassword").click();
    },
    async alertConfirmationConvenio(type, titleConfirmation) {

      if (type === "habilitar") {
        this.duplicar = true;
        this.showB = true;
        this.enableInputs();
        return;
      }

      this.showB = false;

      if (type == 'duplicar' || type == 'guardar') {

        const fakeForm = document.querySelector("#formMain");
        if (!form.validate(fakeForm)) {
          this.$swal("Error", "Todos los campos son obligatorios");
          this.showB = true;
          return;
        }
        let validateEmail = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/)
      
        if (!validateEmail.test(this.email)) {
          this.$swal("Alerta", "Ingrese un Correo electronico valido.");
          return;
        }

        if (this.mesVencimiento.length < 2 || this.mesVencimiento.length > 2) {
          this.$swal("Alerta", "El formato de Mes de vencimiento es invalido");
          this.showB = true;
          console.log("entra aqui");
          return;
        }
        if (this.anioVencimiento.length < 4 || this.anioVencimiento.length > 4) {
          this.$swal("Alerta", "El formato de Año de vencimiento es invalido");
          this.showB = true;
          return;
        }

        if (this.diaProgramacion == '' || this.diaProgramacion == null) {
          this.diaProgramacion = -1;
        }
        if (this.idConvenioGeneral == "") {

          if (this.banco == 16) {
            if (this.numT.length < 18 || this.numT.length > 18) {
              this.$swal("Alerta", "El formato de Numero de tarjeta es invalido");
              this.showB = true;
              console.log("entra aqui");
              return;
            }
            if (this.cvvTarjeta.length < 4 || this.cvvTarjeta.length > 4) {
              this.$swal("Alerta", "El formato de CVV es invalido");
              this.showB = true;
              return;
            }
          } else {

            if (this.cvvTarjeta.length < 3 || this.cvvTarjeta.length > 3) {
              this.$swal("Alerta", "El formato de CVV es invalido");
              this.showB = true;
              return;
            }
            if (this.numT.length < 19 || this.numT.length > 19) {
              this.$swal("Alerta", "El formato de Numero de tarjeta es invalido");
              console.log(" O entra aqui");
              this.showB = true;
              return;
            }
          }
        }

      }

      await this.$swal.fire({
        title: titleConfirmation,
        text: "Esta acción no se puede revertir",
        showCancelButton: true,
        confirmButtonText: 'Si, aceptar',
        cancelButtonText: 'Cancelar',
        reverseButtons: true
      }).then(async (result) => {

        if (!result.isConfirmed) {
          this.showB = true;
          return;
        }
        if (result.isConfirmed) {
          switch (type) {
            case "nuevo":
              this.clearGeneralForm();
              this.$swal("Exito", "Nuevo convenio generado exitosamente");
              break;
            case "duplicar":
              await this.duplicaConvenio();
              break;
            case "eliminar":
              await this.eliminaConvenio();
              break;
            case "guardar":
              if (this.idConvenioGeneral !== "") {
                await this.actualizarConvenio();
              } else {
                await this.altaConvenio();
              }

              break;
            default:
              break;
          }
        }
      })
      data: {
        disabled: 1
      }
    },
    async changePassword() {

      const fakeForm = document.querySelector("#formChangePassword");

      if (!form.validate(fakeForm)) {
        this.alertMessageChangePasswordError = "Todos los campos son obligatorios";
        return;
      }

      if (this.newPassword === this.confirmPassword) {
        const payload = {
          metodo: "COBRANZACAMBIARACCESOMOSTRARINFO",
          data: {
            pContra: this.newPassword,
            pIdUsuario: localStorage.getItem("userId"),
            pIdUsuarioRegistro: localStorage.getItem("userId"),
            pActivo: "1",
          },
        };

        const res = await this.$store.dispatch("metodoPost", payload);
        if (res) {
          const response = this.$store.getters.getRespuestaREST;

          this.alertMessageChangePasswordError = "";
          this.alertMessageChangePasswordSuccess = "";

          if (response[0].valor === -1) {
            this.alertMessageChangePasswordError = response[0].mensaje;
          } else {
            document.getElementById("closeModalChangePassword").click();
            this.$swal("Exito", response[0].mensaje);
          }
        }
      }
    },

    clearGeneralForm() {
      this.isNew = false;
      window.location.href = `${location.origin}/#/cobranza/convenios`;
      this.idConvenioGeneral = "";
      this.idElementoGeneral = "";
      this.idCEGeneral = "";

      this.anioGeneral = "";
      this.folioGeneral = "";

      this.tipoConvenio = 0;
      this.banco = 0;
      this.tipoTarjeta = 0;
      this.situacionConvenio = 0;
      this.email = "";
      this.telefono = "";

      this.situacion = 0;
      this.numeroTarjeta = "";
      this.titular = "";
      this.mesVencimiento = "";
      this.anioVencimiento = "";
      this.cvvTarjeta = "";
      this.diaProgramacion = "";
      this.tarjetaEncriptada = "";
      this.cvvEncriptada = "";

      this.asignacionPolizas = [];

      this.limpiarBuscador(false, true);
    },
    limpiarBuscador(modal, table) {
      this.modals = modal;
      this.poliza = "";
      this.endoso = "";
      this.noFilial = "";
      this.nombreFilial = "";
      this.folio = "";
      this.ramo = 0;

      this.currentPage = 1;
      this.totalPages = 0;


      if (table) {

        this.polizasBuscador = [];
      }
    },
    replaceMes(e) {
      this.mesVencimiento = e.target.value.replace(/\D/g, '')
    },
    replaceTelefono(e) {
      this.telefono = e.target.value.replace(/\D/g, '')
    },
    replaceAnio(e) {
      this.anioVencimiento = e.target.value.replace(/\D/g, '')
    },
    replaceCVV(e) {
      this.cvvTarjeta = e.target.value.replace(/\D/g, '')
    },
    replaceTarget(e) {
      this.numT = e.target.value;

      this.numeroTarjeta = e.target.value
        .replace(/\s/g, '').replace(/\D/g, '')
        .replace(/([0-9]{4})/g, '$1 ').trim();
    },
  },

  async mounted() {
    
    await this.obtenerCatalogo("TipoConvenio");
    await this.obtenerCatalogo("Bancos");
    await this.obtenerCatalogo("TipoElemento");
    await this.obtenerCatalogo("SituacionConvenio");
    await this.obtenerCatalogo("SituacionElemento");
    await this.obtenerCatalogo("Sistema");
    await this.obtenerCatalogo("RamosDanios");
    
    this.isNew = this.$route.query.idConvenio && this.$route.query.idElemento && this.$route.query.idCE;
    
    if (this.isNew) {
      
      this.idConvenioGeneral = this.$route.query.idConvenio;
      this.idElementoGeneral = this.$route.query.idElemento;
      this.idCEGeneral = this.$route.query.idCE;
      await this.consultaDetallesConvenio();
    }
    this.consultaRol();
  },


};
</script>